/// <amd-module name="VSSUI/Components/List/ListDragImage" />
import * as React from "react";

import { Icon } from "VSSUI/Icon";
import { css } from "VSSUI/Util";

import { IListDragImageProps } from "./ListDragImage.Props";

export const ListDragImage = (props: IListDragImageProps) => {
    return (
        <>
            {props.iconProps && <Icon {...props.iconProps} className={css(props.iconProps.className, "flex-noshrink icon-margin")} />}
            <span className="text-ellipsis">{props.text}</span>
        </>
    );
};
